<template>
  <div>
    <TopBar :page="topBarData" @menuItemClick="topMenuClicked" @addBtnClick="addBtnClicked"/>

    <v-container fluid>
      <v-row>
        <v-col>
          <DailyTable />
        </v-col>
      </v-row>
    </v-container>

    <DailyFilter :openFilter="openFilter" @closeDialog="openFilter=false;" />
    <NewLeadDialog :dialogOpen="newLeadDialogOpen" @close-dialog="newLeadDialogOpen=false;" />

    <v-dialog v-model="timerExplainedOpen" width="300">
      <v-card class="pb-4">

        <v-card-title>
          Auto Data Refresh
          <v-spacer></v-spacer>
          {{this.time}}s
        </v-card-title>

        <v-card-text>
          No need to refresh this page, every 30 seconds the data will be refreshed and the latest leads will be shown.
        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DailyTable from "@/components/Daily/DailyTable";
import DailyFilter from "@/components/Daily/DailyFilter";
import NewLeadDialog from "@/components/Daily/NewLeadDialog";
import TopBar from "@/components/Layout/TopBar";

import { mapActions } from 'vuex';

export default {
  components: {DailyTable,DailyFilter,TopBar,NewLeadDialog},
  
  data() {
    return {
      topBarData: {
        name: 'Daily Leads',
        type: 'daily',
        showSearch: true,
        menu: true,
        breadcrumbs: [],
        additionalButtons: [
          {
            inner: 'filter',
            color: 'secondary',
            method: 'openFilter',
          },
          {
            inner: 'refresh',
            color: 'primary',
            method: 'refreshLeads',
          },
        ],
        showBeehiveIcon: false,
      },
      openFilter: false,
      newLeadDialogOpen: false,
      timerTo: 30,
      timer: 0,
      interval: '',
      time: 0,
      timerExplainedOpen: false,
    }
  },
  
  async mounted () {
    await this.resetTimer();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    ...mapActions('daily', ['loadDailyLeads']),

    async resetTimer(){
      this.interval = setInterval(async ()=>{
        this.timer++;
        if(this.timer===this.timerTo){
          this.timer = 0;
          await this.loadDailyLeads();
          clearInterval(this.interval);
          this.resetTimer();
        }
        this.time = this.timerTo - this.timer;
        this.topBarData.additionalButtons[1].inner = `refresh in ${this.time}s`;
      },1000);
    },

    topMenuClicked(menuItem){
      switch(menuItem){
        case 'newLead':
          this.newLeadDialogOpen = true;
          break;
      }
    },
    
    async addBtnClicked(btnName){
      switch(btnName){
        case 'openFilter':
          this.openFilter = true;
          break
        case 'refreshLeads':
          this.timerExplainedOpen = true;
          break
      }
    },
  },
}
</script>

<style>
</style>
